
import { Moon } from "lucide-react"
import { SleepCellBase } from "./SleepCellBase"

interface SleepDurationCellProps {
  durationMinutes: number | null
}

export function SleepDurationCell({ durationMinutes }: SleepDurationCellProps) {
  const formatDuration = (minutes: number | null): string => {
    if (minutes === null || minutes === undefined) return "TBD"
    if (isNaN(minutes) || minutes <= 0) return "TBD"
    
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60
    
    if (hours === 0) return `${mins} ${mins === 1 ? 'minute' : 'minutes'}`
    if (mins === 0) return `${hours} ${hours === 1 ? 'hour' : 'hours'}`
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ${mins} ${mins === 1 ? 'minute' : 'minutes'}`
  }

  return (
    <SleepCellBase icon={Moon} iconColor="text-indigo-400">
      {formatDuration(durationMinutes)}
    </SleepCellBase>
  )
}
